import React, { useEffect, useState } from "react";
import AccordionComponent from "../../../../common/Accordion";
import {
  addInvoiceUserComments,
  getInvoiceUserComments,
  updateInvoiceUserComments,
} from "../../../../services/ManageInvoiceAPI";
import Snackbar from "../../../../common/Snackbar";
import { Button, Col, Row, Table } from "react-bootstrap";
import { INVOICE_COMMENTS } from "../actions/lineItemsConstant";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import { formattedDate } from "../../../../utils/dateUtils";

const ViewComments = ({ lineItemID, onClose }: any) => {
  const [viewListKey, setViewInvoiceKey] = useState<string | null>("0");
  const [commentsData, setCommentsData] = useState<any[]>([]);
  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [invoiceComments, setInvoiceComments] = useState<string>("");
  const [invoiceEditComments, setInvoiceEditComments] = useState<string>("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const headers = INVOICE_COMMENTS;

  const getSummaryDetails = async () => {
    try {
      const commentsDetails = await getInvoiceUserComments(lineItemID);

      const mappedData = commentsDetails.map((item: any) => ({
        ...item,

        uploadedBy: `${formattedDate(item.modifiedDate)} | ${item.modifiedByName}`,
      }));

      if (commentsDetails) {
        setCommentsData(mappedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (lineItemID) {
      getSummaryDetails();
    }
  }, [lineItemID]);

  const validateComments = () => {
    const errors = [];

    if (!editingRowId && !invoiceComments) {
      errors.push("Please enter the comment.");
    }

    if (editingRowId && !invoiceEditComments) {
      errors.push("Please enter the comment.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const onSave = async () => {
    if (!validateComments()) return;
    try {
      const addPayload = {
        invoiceLineItemStdChgId: lineItemID,
        userComment: invoiceComments,
      };

      const response = await addInvoiceUserComments(addPayload);

      if (response?.isSuccess) {
        setSnackbarMessage("Comments added successfully");
        setError("success");
        setSnackbarOpen(true);

        setTimeout(() => {
          onClose?.();
        }, 1000);
      }
    } catch (error) {
      console.error("Error adding comments:", error);
    }
  };

  const handleEditRow = (row: any) => {
    setEditingRowId(row.commentId);

    setInvoiceEditComments(row.userComment);
  };

  const onUpdateComments = async () => {
    if (!validateComments()) return;
    try {
      const addPayload = {
        invoiceLineItemStdChgId: lineItemID,
        commentId: editingRowId,
        newComment: invoiceEditComments,
      };

      const response = await updateInvoiceUserComments(addPayload);

      if (response?.isSuccess) {
        setSnackbarMessage("Comments updated successfully");
        setError("success");
        setSnackbarOpen(true);
        setEditingRowId(null);
        getSummaryDetails();
      }
    } catch (error) {
      console.error("Error updating comments:", error);
    }
  };

  const resetEditRow = () => {
    setEditingRowId(null);
    setInvoiceEditComments("");
  };

  const invoiceListAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={viewListKey}
      onSelect={(key) => setViewInvoiceKey(key as string)}
    />
  );
  const [addKey, setAddKey] = useState<string | null>("0");

  const invoiceAddAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={addKey}
      onSelect={(key) => setAddKey(key as string)}
    />
  );
  return (
    <>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      {invoiceListAccordion([
        {
          title: "List",
          content: (
            <>
              <div className="table-responsive border-0 mb-2">
                <Table>
                  <thead>
                    <tr>
                      {headers.map((header) => (
                        // <th key={header.key} style={thStyle}>
                        <th
                          key={header.key}
                          style={{
                            border: "none",
                            padding: "8px",
                            backgroundColor: "#e0f7fa",
                            color: "#000",
                            cursor: header.sortable ? "pointer" : "default",
                            position:
                              header.key === "actions" ? "sticky" : "sticky",
                            top: 0,
                            right: header.key === "actions" ? 0 : undefined,
                            zIndex: header.key === "actions" ? 5 : -90,

                            backgroundClip: "padding-box",

                            textAlign: [
                              "actions",
                              "totalQuantityPgLn",
                            ].includes(header.key)
                              ? "center"
                              : "left",
                            ...header.style,
                          }}
                        >
                          <div
                            style={{
                              display: [
                                "actions",
                                "totalQuantityPgLn",
                              ].includes(header.key)
                                ? "flex"
                                : "flex",

                              justifyContent: [
                                "actions",
                                "totalQuantityPgLn",
                              ].includes(header.key)
                                ? "space-evenly"
                                : "space-between",

                              alignItems: "center",
                            }}
                          >
                            <span>{header.label}</span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {commentsData?.length > 0 &&
                      commentsData.map((row, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 1 ? "white" : "#f2f2f2",
                          }}
                        >
                          {headers.map((header) => {
                            const cellContent = row[header.key];

                            return (
                              <td
                                key={header.key}
                                style={{
                                  padding: header.isNumeric
                                    ? "8px 20px 8px 8px"
                                    : "8px",
                                  textAlign: header.isNumeric
                                    ? "right"
                                    : "left",
                                }}
                              >
                                {header.key === "actions" ? (
                                  editingRowId === row.commentId ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "12px",
                                      }}
                                    >
                                      <span
                                        className="material-symbols-outlined"
                                        style={{
                                          cursor: "pointer",
                                          color: "#0092d5",
                                        }}
                                        onClick={() => onUpdateComments()}
                                      >
                                        save
                                      </span>

                                      <span
                                        className="material-symbols-outlined"
                                        style={{
                                          cursor: "pointer",
                                          color: "#dc3545",
                                        }}
                                        onClick={resetEditRow}
                                      >
                                        close
                                      </span>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "12px",
                                      }}
                                    >
                                      <span
                                        className="material-symbols-outlined"
                                        style={{
                                          cursor: "pointer",
                                          color: "#0092d5",
                                        }}
                                        onClick={() => handleEditRow(row)}
                                      >
                                        edit
                                      </span>
                                    </div>
                                  )
                                ) : editingRowId === row.commentId ? (
                                  header.key === "userComment" ? (
                                    <>
                                      <MultilineTextBox
                                        label="Comments"
                                        name="comments"
                                        value={invoiceEditComments ?? ""}
                                        onChange={(e) => {
                                          let value = e.target.value;
                                          if (value.startsWith(" ")) return;
                                          value = value?.trimStart();
                                          value = value.replace(/ {2,}/g, " ");
                                          setInvoiceEditComments(value);
                                        }}
                                        maxLength={1000}
                                      />
                                    </>
                                  ) : (
                                    cellContent
                                  )
                                ) : (
                                  cellContent
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </>
          ),
        },
      ])}
      {invoiceAddAccordion([
        {
          title: "Add Comments",
          content: (
            <>
              <Row className="mt-1">
                <Col sm={12} className="notemultiline">
                  <MultilineTextBox
                    label="Comments"
                    name="comments"
                    value={invoiceComments ?? ""}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setInvoiceComments(value);
                    }}
                    maxLength={1000}
                  />
                </Col>
              </Row>
            </>
          ),
        },
      ])}
      <Row id="team-form-buttons" className="bottom-fixed-btn">
        <Col md={6} className="d-flex justify-content-start mb-2 "></Col>
        <Col md={6} className="d-flex justify-content-end mb-2 px-0 pe-3">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={onClose}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={onSave}
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ViewComments;
